import { render, staticRenderFns } from "./customer_records.vue?vue&type=template&id=6df61f6f&scoped=true&"
import script from "./customer_records.vue?vue&type=script&lang=js&"
export * from "./customer_records.vue?vue&type=script&lang=js&"
import style0 from "./customer_records.vue?vue&type=style&index=0&id=6df61f6f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6df61f6f",
  null
  
)

export default component.exports